<template>
  <TabsLayout>
    <ElTabPane name="designerTeam" label="设计个人（新）" v-if="authPlanner"></ElTabPane>
    <ElTabPane name="staffNew" label="策划人员（新）" v-if="authStaff"></ElTabPane>
    <ElTabPane name="works" label="素材数据" v-if="authWorks"></ElTabPane>
    <ElTabPane name="performance" label="设计KPI设置" v-if="authPerformance"></ElTabPane>
    <ElTabPane name="calculator" label="回款计算器" v-if="authCalculator"></ElTabPane>
    <ElTabPane name="staffkpi" label="策划KPI设置" v-if="authStaffkpi"></ElTabPane>
  </TabsLayout>
</template>
<script>
import TabsLayout from '@/views/report/tabs-layout.vue'
export default {
  name: 'personal',
  components: {
    TabsLayout
  },
  computed: {
    authPlanner() {
      return this.$store.state.accessAuth.includes('M20794')
    },
    authStaff() {
      return this.$store.state.accessAuth.includes('M20796')
    },
    authWorks() {
      return this.$store.state.accessAuth.includes('M20795')
    },
    authPerformance() {
      return this.$store.state.accessAuth.includes('M20750')
    },
    authCalculator() {
      return this.$store.state.accessAuth.includes('M20749')
    },
    authStaffkpi() {
      return this.$store.state.accessAuth.includes('M20797')
    }
  }
}
</script>
